import { i18n } from "@dehub/theme";
import { showNotification } from "@mantine/notifications";
import { IconCheck, IconAlertTriangle } from "@tabler/icons-react";
import React from "react";

const baseClassNames = {
  icon: "de-toast-icon",
  body: "de-toast-body",
  title: "de-toast-title",
  description: "de-toast-description",
  closeButton: "de-toast-close",
};

const translateIfKey = (msg: string): string => {
  if (typeof msg !== "string" || !msg.startsWith("error.")) return msg;
  const translated = i18n.t(msg, { ns: "common", defaultValue: "" });
  if (typeof translated === "string" && translated.length > 0) return translated;
  return i18n.t("error.title", { ns: "common", defaultValue: "Алдаа гарлаа" });
};

const success = (message: string, _description?: string, title?: string) => {
  showNotification({
    withBorder: false,
    color: undefined,
    icon: React.createElement(IconCheck, { size: 20, stroke: 2.4 }),
    title: title || "Хүсэлт амжилттай!",
    message,
    autoClose: 3500,
    classNames: { ...baseClassNames, root: "de-toast de-toast--success" },
  });
};

const error = (message: string) => {
  showNotification({
    withBorder: false,
    color: undefined,
    icon: React.createElement(IconAlertTriangle, { size: 20, stroke: 2.4 }),
    title: "Хүсэлт амжилтгүй!",
    message: translateIfKey(message),
    autoClose: 5000,
    classNames: { ...baseClassNames, root: "de-toast de-toast--error" },
  });
};

export const Message = {
  success,
  error,
};
